export enum SpaceframeAppearance {
    Antares,
    ClassJCargoShip,
    Eleos,
    Freighter,
    JovisType,
    Merchantman,
    XhosaType,
    KaplanF17PatrolFrigate,
    ConestogaType,

    // Romulan
    Aelahl,
    BirdOfPrey22ndCentury,
    Tliss,
    RomulanD7,
    Whitewind,
    DDeridex,
    RomulanScienceVessel,
    Mogai,
    RedLadyType,
    Snakehead,
    ScimitarType,
    Khnial,


    // Orion
    DVar,
    Intruder,
    Interceptor,
    Orchid,

    // Discovery-era Federation ships
    Kirk,
    Janeway,
    Friendship,
    Eisenberg
}